<template>
  <div class="notification-stack" aria-live="polite" aria-atomic="false">
    <transition-group
      name="notification-slide"
      tag="div"
      class="notification-stack-list"
    >
      <div
        v-for="notification in notifications"
        :key="notification.id"
        class="notification-card"
        :class="`notification-${notification.type}`"
      >
        <div class="notification-icon" aria-hidden="true">
          <span class="fas" :class="iconClass(notification.type)"></span>
        </div>
        <div class="notification-content">
          <strong class="notification-title">{{ notification.title }}</strong>
          <p v-if="notification.message" class="notification-message">
            {{ notification.message }}
          </p>
        </div>
        <button
          class="btn btn-sm notification-close"
          type="button"
          aria-label="Закрыть уведомление"
          @click="dismiss(notification.id)"
        >
          <span class="fas fa-times"></span>
        </button>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  computed: {
    notifications() {
      return this.$store.getters.notifications;
    },
  },
  methods: {
    iconClass(type) {
      if (type === "success") return "fa-check-circle";
      if (type === "warning") return "fa-exclamation-triangle";
      return "fa-times-circle";
    },
    dismiss(id) {
      this.$store.dispatch("dismissNotification", id);
    },
  },
};
</script>
